module.exports = __webpack_public_path__ + "static/media/bell.eaa71ad2.svg";